import request from '@/service/request';
import api from '@/service/contant/api';

// 广告位
export function getAD(params, opt = {}) {
  return request({
    url: api.common.getAD,
    method: 'GET',
    params,
    ...opt,
  });
}

export function gsdAD(data, opt = {}) {
  return request({
    url: api.common.getAD,
    method: 'GET',
    parm: {
      ...data,
    },
    ...opt,
  });
}

export function getCustomServiceUrl(data, opt = {}) {
  return request({
    url: 'https://customer-api.chuxingyouhui.com/ccm/chat_url',
    // url: 'https://customer-api.chuxingyouhui.com/ccm/chat_url',
    method: 'POST',
    data,
    ...opt,
  });
}

export function cancelPay(data, opt = {}) {
  return request({
    url: api.common.cancelPay,
    // url: 'https://customer-api.chuxingyouhui.com/ccm/chat_url',
    method: 'POST',
    data,
    ...opt,
  });
}

export function userLogin(data, opt = {}) {
  return request({
    url: api.common.login,
    method: 'POST',
    data,
    headers: {
      'auth-token': opt['auth-token'],
      token: 'fake_java_token',
      // 'black-token': null,
    },
  });
}

export function tokenChange(data, opt = {}) {
  return request({
    url: api.common.tokenChange,
    // url: 'https://customer-api.chuxingyouhui.com/ccm/chat_url',
    method: 'POST',
    data,
    ...opt,
  });
}

export function getMemberIdByUserId(data, opt = {}) {
  return request({
    url: api.common.getMemberIdByUserId,
    // url: 'https://customer-api.chuxingyouhui.com/ccm/chat_url',
    method: 'POST',
    data,
    ...opt,
  });
}

export function uniteLogin(data, opt = {}) {
  return request({
    url: api.common.uniteLogin,
    method: 'POST',
    data,
    ...opt,
  });
}
